import { render, staticRenderFns } from "./MemberListIframe.vue?vue&type=template&id=2b74ba4d&"
import script from "./MemberListIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports